/* eslint-disable no-undef */
/* eslint-disable wrap-iife */
/* eslint-disable no-magic-numbers */
/* eslint-disable max-statements */

( function( $ ) {

    // Allows user to hover over Bootstrap nav drop-downs to make submenu appear, instead of clicking
    $(function($) {
        if ($(window).width() > 768) {
          $('.navbar .dropdown').hover(function() {
            $(this).find('.dropdown-menu').first().stop(true, true).delay(250).slideDown();
      
          }, function() {
            $(this).find('.dropdown-menu').first().stop(true, true).delay(100).slideUp();
      
          });
      
          $('.navbar .dropdown > a').click(function() {
            location.href = this.href;
          });
      
        }
      })

} )( jQuery );



// WEBPACK FOOTER //
// ./src/js/inc/bootstrap-overrides.js